export var authLocalStorage = function authLocalStorage(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$storageKey = _ref.storageKey,
      storageKey = _ref$storageKey === void 0 ? 'sw_auth' : _ref$storageKey;

  return {
    load: function load() {
      return new Promise(function (res) {
        try {
          var json = localStorage.getItem(storageKey);

          if (json == null) {
            res(undefined);
          } else {
            res(JSON.parse(json));
          }
        } catch (err) {
          process.env.NODE_ENV === 'development' ? console.error('Failed to load credential from storage', err) : void 0;
          res(undefined);
        }
      });
    },
    store: function store(cred) {
      return new Promise(function (res) {
        try {
          if (cred) {
            localStorage.setItem(storageKey, JSON.stringify(cred));
          } else {
            localStorage.removeItem(storageKey);
          }

          res();
        } catch (err) {
          process.env.NODE_ENV === 'development' ? console.error('Failed to store credential to storage', err) : void 0;
          res();
        }
      });
    }
  };
};